import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-coaching-courses',
  templateUrl: './business-coaching-courses.component.html',
  styleUrls: ['./business-coaching-courses.component.scss']
})
export class BusinessCoachingCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
